import { Link } from "react-router-dom";
import PrivacySEO from "../../components/SEO/PrivacySEO";
import routes from "../../routes/routeDefinitions";

const Privacy = () => {
  return (
    <>
      <PrivacySEO />
      <div className="pt-24 md:pt-28 lg:pt-32 pb-140 md:pb-32 lg:pb-40 px-6 md:px-10 xl:px-20 max-w-4xl mx-auto">
        <h1 className="text-4xl xl:text-5xl text-gray-900 mb-4">
          Privacy Policy
        </h1>
        <p className="text-sm text-gray-500 mb-10">
          Last updated: August 8, 2026
        </p>

        <div className="space-y-8 text-gray-700 leading-relaxed text-base xl:text-lg">
          <section>
            <p>
              NABAZAT AL QALB (&quot;we&quot;, &quot;us&quot;, or &quot;our&quot;)
              respects your privacy. This Privacy Policy explains how we
              collect, use, disclose, and protect information when you visit
              our website or communicate with us about our medical supplies and
              healthcare solutions.
            </p>
          </section>

          <section>
            <h2 className="text-2xl xl:text-3xl text-gray-900 mb-3">
              Information We Collect
            </h2>
            <p className="mb-3">
              We may collect information you provide directly to us, including:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Name, email address, and phone number</li>
              <li>Company or organization details</li>
              <li>Messages submitted through our contact forms</li>
              <li>Subscription email addresses, if you join our mailing list</li>
            </ul>
            <p className="mt-3">
              We may also collect limited technical information automatically,
              such as browser type, device information, and pages visited, to
              help us operate and improve our website.
            </p>
          </section>

          <section>
            <h2 className="text-2xl xl:text-3xl text-gray-900 mb-3">
              How We Use Your Information
            </h2>
            <p className="mb-3">We use the information we collect to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Respond to inquiries and provide customer support</li>
              <li>Share information about our products and services</li>
              <li>Improve our website, content, and user experience</li>
              <li>Send updates or newsletters when you have subscribed</li>
              <li>Comply with legal and regulatory obligations</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl xl:text-3xl text-gray-900 mb-3">
              Sharing of Information
            </h2>
            <p>
              We do not sell your personal information. We may share information
              with trusted service providers who help us operate our website or
              business, or when required by law, regulation, or legal process.
            </p>
          </section>

          <section>
            <h2 className="text-2xl xl:text-3xl text-gray-900 mb-3">
              Data Security
            </h2>
            <p>
              We take reasonable administrative and technical measures to
              protect personal information against unauthorized access, loss,
              misuse, or alteration. No method of transmission over the internet
              is completely secure, so we cannot guarantee absolute security.
            </p>
          </section>

          <section>
            <h2 className="text-2xl xl:text-3xl text-gray-900 mb-3">
              Cookies and Similar Technologies
            </h2>
            <p>
              Our website may use cookies or similar technologies to support
              basic site functionality and understand how visitors use our
              pages. You can control cookies through your browser settings.
            </p>
          </section>

          <section>
            <h2 className="text-2xl xl:text-3xl text-gray-900 mb-3">
              Your Choices
            </h2>
            <p>
              You may request access to, correction of, or deletion of personal
              information we hold about you, subject to applicable law. You may
              also unsubscribe from marketing communications at any time by
              contacting us.
            </p>
          </section>

          <section>
            <h2 className="text-2xl xl:text-3xl text-gray-900 mb-3">
              Third-Party Links
            </h2>
            <p>
              Our website may contain links to third-party websites. We are not
              responsible for the privacy practices or content of those sites.
              We encourage you to review their privacy policies.
            </p>
          </section>

          <section>
            <h2 className="text-2xl xl:text-3xl text-gray-900 mb-3">
              Changes to This Policy
            </h2>
            <p>
              We may update this Privacy Policy from time to time. Any changes
              will be posted on this page with an updated revision date. Your
              continued use of the website after changes are posted constitutes
              acceptance of the updated policy.
            </p>
          </section>

          <section>
            <h2 className="text-2xl xl:text-3xl text-gray-900 mb-3">
              Contact Us
            </h2>
            <p>
              If you have questions about this Privacy Policy or how we handle
              personal information, please contact us through our{" "}
              <Link
                to={routes.contact.path}
                className="text-blue-700 hover:text-blue-900 underline"
              >
                Contact
              </Link>{" "}
              page or reach out using the details listed on our website.
            </p>
          </section>
        </div>
      </div>
    </>
  );
};

export default Privacy;
